import { render, staticRenderFns } from "./NewSectorDialog.vue?vue&type=template&id=241b5635&scoped=true"
import script from "./NewSectorDialog.vue?vue&type=script&lang=js"
export * from "./NewSectorDialog.vue?vue&type=script&lang=js"
import style0 from "./NewSectorDialog.vue?vue&type=style&index=0&id=241b5635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b5635",
  null
  
)

export default component.exports